module.exports = __webpack_public_path__ + "static/TheKooples-5c78cde5f295e03622a078fc34fca5ee.jpg";